<template>
  <div class="tw-relative">
    <img
      src="../../../assets/images/gradient-rainbow-background.png"
      class="tw-pointer-events-none tw-absolute tw-z-0 tw-h-screen tw-w-full"
      alt=""
    />
    <div class="tw-relative tw-mx-auto tw-max-w-xl tw-p-8">
      <a href="https://growthmentor.com" target="_blank">
        <img
          src="../../../assets/images/growthmentor-logo.png"
          alt="GrowthMentor logo"
          class="tw-mx-auto tw-w-40"
        />
      </a>
      <div class="tw-mt-8 tw-rounded-md tw-bg-white tw-p-8 tw-shadow-xxl">
        <h1 class="tw-heading-1">Welcome back, sign in.</h1>
        <form @submit.prevent="submit" class="tw-mt-4 tw-space-y-4">
          <FormInput
            v-model="form.user.email"
            type="email"
            autofocus
            autocapitalize="off"
            autocomplete="email"
            test_id="email"
          >
            <template #label>Email</template>
          </FormInput>
          <FormInput
            v-model="form.user.password"
            type="password"
            autocomplete="current-password"
            test_id="password"
          >
            <template #label>Password</template>
          </FormInput>
          <div class="tw-text-sm tw-font-semibold tw-text-error-500">
            {{ !form.isDirty ? $page.props.flash.warning : null }}
          </div>
          <div
            class="tw-mt-4 tw-flex tw-flex-col tw-justify-between tw-space-y-4 sm:tw-flex-row sm:tw-items-center sm:tw-space-y-0"
          >
            <FormCheckbox v-model="form.user.remember_me">
              Remember me
            </FormCheckbox>
            <InertiaLink
              href="/users/password/new"
              class="tw-text-sm tw-text-neutral-400"
            >
              Forgot password?
            </InertiaLink>
          </div>
          <BaseButton
            type="submit"
            color="purple"
            is-block
            :is-rounded="false"
            size="large"
            class="tw-rounded-lg tw-shadow-md"
            :is-disabled="form.processing"
            test_id="sign-in-button"
          >
            Sign in
            <LoadingCircle v-if="form.processing" size="16" class="tw-ml-2" />
          </BaseButton>
        </form>
        <div class="tw-mt-6">
          <div class="tw-mt-8 tw-text-center tw-text-sm">
            or sign in with your social account
          </div>

          <SocialMediaLoginButtons
            class="tw-mt-4 tw-flex tw-flex-col tw-space-y-2"
          />
        </div>
        <hr class="tw-mb-4 tw-mt-12" />
        <div class="tw-text-sm tw-text-neutral-500">
          Don't have an account?
          <InertiaLink
            href="/mentees/sign_up"
            class="tw-underline hover:tw-text-neutral-600 hover:tw-underline"
          >
            Sign up
          </InertiaLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import FormInput from '@/shared/components/forms/FormInput.vue'
import FormCheckbox from '@/shared/components/forms/FormCheckbox.vue'
import BaseButton from '@/shared/components/BaseButton.vue'
import SocialMediaLoginButtons from '@/modules/growthmentor/auth/components/SocialMediaLoginButtons.vue'
import LoadingCircle from '@/shared/components/LoadingCircle.vue'
import { useForm } from '@inertiajs/vue3'

const form = useForm({
  user: {
    email: '',
    password: '',
    remember_me: null,
  },
})

const submit = () => {
  form.post('/users/sign_in')
}
</script>

<script>
import AuthLayout from '@/layouts/AuthLayout.vue'

export default {
  layout: AuthLayout,
}
</script>
